import { HttpClient, HttpHeaders } from '@angular/common/http';

export class APIService {
  currentUser;
  private baseUrl = "https://joinus-test.albaraka.com.sy/backend/public/api/"; //"https://joinus-test.albaraka.com.sy/backend/public/api/"; // "http://10.0.206.152:8080/join-us-admin/backend/public/api/" ;//"api/
  protected endPoint = "";
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
    })
  };
  constructor(protected http: HttpClient) {
  }

  get url() {
    return this.baseUrl + this.endPoint;
  }


}
